<template>
  <div class="container-fluid p-3">
    <div class="card">
      <div class="card-header">
        <h5 class="text-center">HOTELES</h5>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label for="fecha_reg">Fecha de registro</label>
              <input
                type="date"
                class="form-control"
                id="fecha_reg"
                v-model="fecha_reg"
              />
            </div>
          </div>
          <div class="col">
            <button
              class="btn btn-info mt-4"
              type="button"
              @click="getHoteles(fecha_reg)"
            >
              <i class="fa fa-search"></i>
            </button>
          </div>
        </div>
        <div class="mt-5" v-if="hoteles.length > 0">
          <pie-chart
            :chartData="hoteles"
            :options="chartOptions"
            label="aereos"
          ></pie-chart>
        </div>
        <div class="pt-5">
          <div class="table-responsive">
            <table class="table">
              <thead class="thead-active">
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Empresa Razon Social</th>
                  <th scope="col">Total Registros</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(hotel, index) in hoteles" :key="index">
                  <th scope="row">{{ index + 1 }}</th>
                  <td>{{ hotel.emp_razon_social }}</td>
                  <td>{{ hotel.count }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PieChart from "../../components/graficos/PieChart";
export default {
  components: { PieChart },
  data() {
    return {
      hoteles: {},
      fecha_reg: "", //"2021-12-31",
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
      },
    };
  },
  methods: {
    async getHoteles(fecha_reg) {
      try {
        let res = await this.axios.get(`/reportehoteles/${fecha_reg}`);
        this.hoteles = res.data.contenido;
      } catch (error) {
        this.$alert(error, "Atención", "error");
        this.cargando = false;
      }
    },
  },
};
</script>
